import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'processing/api/v1/processes';

const store = coreStore.queryStore(coreStore.createCoreStore('importProcess', remoteResource, 'importProcesses'));

store.state.runningImportProcesses = []
store.mutations.setRunningProcesses = (state, payload) => {
    state.runningImportProcesses = payload;
}
store.getters.getRunningProcesses = (state) => state.runningImportProcesses;

store.actions.refreshRunningImportProcesses = ({commit}) => {
    return Axios.get(`${remoteResource}?onlyRunning=true`)
        .then(res => commit('setRunningProcesses', res.data));
}

export default store;
